
export function setParamTable (state, paramTable) {
    state.selectedParamTable = paramTable;
}

export function setParamTables (state, data) {
    state.parameters = data
}



// WEBPACK FOOTER //
// ./src/modules/table-parameters/mutations.js